import React from "react";

import FacilityList from "./FacilityList";
import { SearchState } from "./SearchModal";

import { useGetFacility } from "../../utils/useFacility";
import { useMetaData } from "../../utils/useMetaData";

type Props = {
  currentPage: number;
  perView: number;
  keyword: string;
  handleKeyword: (value: string) => void;
  clearSearch: () => void;
  updateQuery: (field: string, value: string | Array<string>) => void;
  getParam: (field: string) => string;
  getParamAll: (field: string) => string[];
  handleSearch: () => void;
};

const FacilityListContainer: React.FC<Props> = ({
  currentPage,
  perView,
  keyword,
  handleKeyword,
  clearSearch,
  updateQuery,
  getParam,
  getParamAll,
  handleSearch,
}) => {
  const prefecture = getParamAll("prefecture");
  const hostEvents = getParam("hostEvents");
  const foodService = getParam("foodService");
  const smoking = getParam("smoking");

  const {
    items: { facilities, totalEntries, totalPage },
    isLoading,
  } = useGetFacility({
    search: keyword ? keyword : undefined,
    page: currentPage,
    per: perView,
    sort_by: "_id",
    desc: true,
    prefecture,
    hostEvents: hostEvents.length ? hostEvents : undefined,
    foodService: foodService.length ? foodService : undefined,
    smoking: smoking.length ? smoking : undefined,
  });

  const handleSearchFunc = (args: SearchState) => {
    for (const [key, value] of Object.entries(args)) {
      updateQuery(key, value);
    }
    handleSearch();
  };

  useMetaData({
    title: "eスポーツ施設・カフェ一覧",
    description:
      "日本全国のeスポーツ施設・カフェの一覧です。ゲームのイベント会場やeスポーツを楽しめる施設などが掲載されています。都道府県やキーワードなどでの検索もご利用いただけます。",
    imgUrl: "",
  });

  return (
    <FacilityList
      facilities={facilities}
      isLoading={isLoading}
      totalEntries={totalEntries}
      totalPages={totalPage}
      currentPage={currentPage}
      perView={perView}
      keyword={keyword}
      handleKeyword={handleKeyword}
      handleSearchFunc={handleSearchFunc}
      clearSearch={clearSearch}
      searchArgs={{
        prefecture: prefecture ?? [],
        hostEvents: hostEvents,
        foodService: foodService,
        smoking: smoking,
      }}
    />
  );
};

export default FacilityListContainer;
